export default "__VITE_PUBLIC_ASSET__4d22ba39__"